import { ColumnType } from '../../../types';
import { ChartSettingsV2MenuItems, } from '../chart-settings-v2-schema.types';
import { createAggregationDropdown, createAllDataLabelVisibilityCheckboxForTreemapChart, createBorderWidthInput, createChartBackgroundColorFormatter, createChartColumnNumberFormatter, createColumnColorPicker, createColumnNameTextInput, createDataLabelAlignmentDropdown, createDataLabelBackgroundFormatter, createDataLabelFontFormatter, createDataLabelMaxLengthInput, createDataLabelNumericFilter, createGradientColorPicker, createMaxDataPointsInput, createPlotAreaBackgroundColorFormatter, createTimeBucketDropdown, createTooltipBackgroundFormatter, createTooltipContentFormatter, createTooltipFieldLabelFormatter, createTooltipFontFormatter, createTooltipVisibilityCheckbox, } from '../schema-composer-utils/common-elements';
import { shouldHideDataLabelsAccordion, shouldHideTooltipSettings, } from '../schema-composer-utils/common-rules';
import { createAccordion, createAccordionItem, createBackgroundImageEditor, createSection, } from '../schema-composer-utils/elements';
const columnSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                properties: {
                                    header: '',
                                    isExpanded: true,
                                    noPadding: true,
                                    variant: 'sideNav',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createAggregationDropdown(),
                                    createColumnColorPicker(),
                                    createGradientColorPicker(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        properties: {
                            spacing: 'ignore',
                        },
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createTimeBucketDropdown(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
];
const dataLabelSettings = [
    createSection({
        isHiddenCallback: shouldHideDataLabelsAccordion,
        children: [
            createAllDataLabelVisibilityCheckboxForTreemapChart(),
            createDataLabelNumericFilter(),
            createDataLabelFontFormatter(),
            createDataLabelMaxLengthInput(),
            createDataLabelAlignmentDropdown(),
            createDataLabelBackgroundFormatter(),
        ],
    }),
];
const tooltipSettings = [
    createSection({
        children: [
            createTooltipVisibilityCheckbox(),
            createTooltipContentFormatter(),
        ],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createTooltipBackgroundFormatter(),
            createTooltipFieldLabelFormatter(),
            createTooltipFontFormatter(),
        ],
        isHiddenCallback: shouldHideTooltipSettings,
    }),
];
const displaySettings = [
    createSection({
        children: [createMaxDataPointsInput(), createBorderWidthInput()],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createAccordion({
                children: [
                    createAccordionItem({
                        properties: {
                            header: 'Background',
                        },
                        children: [
                            createChartBackgroundColorFormatter(),
                            createPlotAreaBackgroundColorFormatter(),
                            createBackgroundImageEditor(),
                        ],
                    }),
                ],
            }),
        ],
    }),
];
export const treemapChartSettingsSchema = {
    [ChartSettingsV2MenuItems.COLUMN]: columnSettings,
    [ChartSettingsV2MenuItems.AXIS]: null,
    [ChartSettingsV2MenuItems.DATA_LABEL]: dataLabelSettings,
    [ChartSettingsV2MenuItems.TOOLTIP]: tooltipSettings,
    [ChartSettingsV2MenuItems.LEGEND]: null,
    [ChartSettingsV2MenuItems.DISPLAY]: displaySettings,
};
//# sourceMappingURL=treemap-schema.js.map